import type { AudioEventName, AudioEventParams, EventPayload } from "../types";

import { track } from "../core";

function getAudioParams(
  player: HTMLAudioElement | null,
): Partial<AudioEventParams> {
  if (!player) {
    return {};
  }

  return {
    position: Math.round(player.currentTime),
    sound: Math.round(player.volume * 100),
    total_length: Math.round(player.duration) || undefined,
  };
}

/**
 * Generate or retrieve an audio playback session ID from sessionStorage.
 * Expires when the browser tab closes.
 */
function getAudioSessionId(): string {
  const SESSION_KEY = "audio_playback_session_id";

  let sessionId = sessionStorage.getItem(SESSION_KEY);

  if (!sessionId) {
    sessionId = crypto.randomUUID();
    sessionStorage.setItem(SESSION_KEY, sessionId);
  }

  return sessionId;
}

/**
 * Track an audio playback event.
 */
function trackAudioEvent(
  eventName: AudioEventName,
  player: HTMLAudioElement | null,
  additionalProps?: Partial<AudioEventParams>,
) {
  const baseProps: Partial<AudioEventParams> = {
    audio_player: additionalProps?.audio_player,
    content_asset_id: additionalProps?.content_asset_id,
    content_pod_id: additionalProps?.content_pod_id,
    session_id: additionalProps?.session_id || getAudioSessionId(),
    ...getAudioParams(player),
  };

  const properties = {
    ...baseProps,
    ...additionalProps,
  };

  return track(eventName, properties as EventPayload);
}

export { trackAudioEvent };
